import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bell, Logo, Search, User } from "@vfit/ui/icons";
import React, { Children, useLayoutEffect, useRef } from "react";
import { handlerClickMenu } from "../../header.utils";
import { ActionsMenu, ActionsMenuList, LogoWrapper, MainContainer, Menu, MenuList } from "./body.style";
import SearchBox from "../SearchBox/SearchBox";
var icons = {
    search: /*#__PURE__*/ _jsx(Search, {}),
    remainder: /*#__PURE__*/ _jsx(Bell, {}),
    profile: /*#__PURE__*/ _jsx(User, {})
};
var Body = function(param) {
    var actionsMenu = param.actionsMenu, menuType = param.menuType, openMenu = param.openMenu, isFirstLevelMenuOpen = param.isFirstLevelMenuOpen, getContainerHeight = param.getContainerHeight, // onTrack,
    headerLogo = param.headerLogo;
    var containerRef = useRef();
    var OVERLOPPED_ITEM_ID = "menu-list";
    useLayoutEffect(function() {
        if (containerRef && containerRef.current && getContainerHeight) {
            getContainerHeight(containerRef.current.clientHeight);
        }
    }, [
        getContainerHeight
    ]);
    return /*#__PURE__*/ _jsxs(MainContainer, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsx("a", {
                href: headerLogo === null || headerLogo === void 0 ? void 0 : headerLogo.url,
                children: /*#__PURE__*/ _jsx(LogoWrapper, {
                    children: /*#__PURE__*/ _jsx(Logo, {})
                })
            }),
            /*#__PURE__*/ _jsx(Menu, {
                id: OVERLOPPED_ITEM_ID,
                children: Children.toArray(menuType === null || menuType === void 0 ? void 0 : menuType.map(function(menu, menuIndex) {
                    /*#__PURE__*/ return _jsx(MenuList, {
                        children: /*#__PURE__*/ _jsx("a", {
                            onClick: function(evt) {
                                return handlerClickMenu(evt, menu);
                            },
                            className: (isFirstLevelMenuOpen === null || isFirstLevelMenuOpen === void 0 ? void 0 : isFirstLevelMenuOpen.isHovered) && (isFirstLevelMenuOpen === null || isFirstLevelMenuOpen === void 0 ? void 0 : isFirstLevelMenuOpen.menuIndex) === menuIndex ? "showLine" : "",
                            onMouseEnter: function() {
                                if (openMenu) {
                                    openMenu({
                                        menuIndex: menuIndex,
                                        isHovered: true
                                    });
                                }
                            },
                            href: menu.url || "/",
                            children: menu.category
                        })
                    });
                }))
            }),
            /*#__PURE__*/ _jsxs(ActionsMenu, {
                children: [
                    /*#__PURE__*/ _jsx(SearchBox, {
                        overlopperItemId: OVERLOPPED_ITEM_ID
                    }),
                    Children.toArray(actionsMenu === null || actionsMenu === void 0 ? void 0 : actionsMenu.map(function(action) {
                        if (!action.url || !icons[(action === null || action === void 0 ? void 0 : action.category) || ""]) return null;
                        return /*#__PURE__*/ _jsx(ActionsMenuList, {
                            children: /*#__PURE__*/ _jsx("a", {
                                href: action.url,
                                style: {
                                    display: "block"
                                },
                                children: icons[action.category]
                            })
                        });
                    }))
                ]
            })
        ]
    });
};
export default Body;
